import React from 'react';
import { Container } from 'reactstrap';
import AssignmentView from './Components/AssignmentView';

const Test = () => {
  document.title = 'Menu Assignment';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid className='px-0'>
          <AssignmentView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Test;
